export const AchievementsIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_36033_735)">
                <path
                    d="M19.9959 2.40608L12 1.03008L3.99719 2.36598L-0.00339869 2.35595L-0.0221644 9.84275L3.92182 12.1319L3.91969 12.9826L9.84428 17.696L9.32807 17.6947L6.4922 18.5619L5.76716 21.3865L8.92916 22.3851L14.9273 22.411L18.1306 21.4157L17.4198 18.5875L14.661 17.7154L14.0611 17.7139L19.951 13.0755L20.0202 13.0211L20.0224 12.1705L23.9778 9.90109L23.9965 2.4161L19.9959 2.40608ZM3.92662 10.2198L1.63791 8.89083L1.65012 4.01778L3.94215 4.02352L3.92662 10.2198ZM17.3622 6.75271L10.6265 13.1066C10.508 13.2172 10.3245 13.2113 10.2121 13.0947L6.59006 9.25041C6.47948 9.13381 6.4854 8.94842 6.60201 8.83784L8.00855 7.51085C8.12697 7.40027 8.31054 7.40619 8.42112 7.52279L10.3173 9.53422C10.4279 9.65082 10.6133 9.65674 10.7299 9.54616L15.6328 4.92166C15.7512 4.81108 15.9347 4.81699 16.0453 4.9336L17.3705 6.33831C17.4811 6.45492 17.4752 6.6403 17.3586 6.75089L17.3622 6.75271ZM22.3225 8.94268L20.0271 10.2602L20.0427 4.06388L22.3347 4.06962L22.3225 8.94268Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_36033_735">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
